
const once = {
  state: {
    count: 5
  },
  mutations: {
    add: (state) => {
      state.count += 1
    }
  },
  actions: {
    ADD_COUNT: ({ commit }) => {
      commit('add')
    }
  }
}
export default once
